export const API_QUERY_DEFAULTS = {
  refetchOnWindowFocus: false,
  retry: 1,
} as const;

export const REFERENCE_STALE_TIME = 30 * 60 * 1000;
export const LISTING_STALE_TIME = 0;
export const FACET_STALE_TIME = 30_000;
